/// <amd-module name="Core/Medius.Core.Web/Scripts/components/taskHandling/shared/modals/shared/utils"/>
import { translate } from "Core/Medius.Core.Web/Scripts/lib/globalization";

export const getTranslatedDocumentType = (documentType: string): string => {
    switch (documentType) {
        case "Medius.Core.Entities.Integration.EDIDocumentImport":
            return translate("#PurchaseToPay/documentReasonCodes/rejectManagementWizard/documentType/eDIDocumentImport");
        case "Medius.ExpenseInvoice.Entities.ExpenseInvoice":
            return translate("#PurchaseToPay/documentReasonCodes/rejectManagementWizard/documentType/expenseInvoice");
        case "Medius.OrderbasedInvoice.Entities.OrderbasedInvoice":
            return translate("#PurchaseToPay/documentReasonCodes/rejectManagementWizard/documentType/orderbasedInvoice");
        case "Medius.Apa.Persistence.PrepaymentInvoice.PrepaymentSupplierInvoice":
            return translate("#PurchaseToPay/documentReasonCodes/rejectManagementWizard/documentType/prepaymentSupplierInvoice");
        case "Medius.ContractbasedInvoice.Entities.ContractbasedInvoice":
            return translate("#PurchaseToPay/documentReasonCodes/rejectManagementWizard/documentType/recurringInvoice");
        default:
            return documentType;
    }
};